module.exports = __webpack_public_path__ + "img/banner-maskex1.e13e9672.webp";